<template>
  <div>
    <div class="share-tips">您分享商品好友下单后，好友用户确认收货且无退款商家将给您寄出商品哦～；好友发起退款您获得商品数量会相应的减少哦</div>
    <router-link
      tag="div"
      to="/address"
      class="share-address"
    >
      <div :class="[info.address ? 'address' : 'notAddress']">{{ info.address ? info.address : "新增收货地址" }}</div>
      <div
        class="name"
        v-show="info.address"
      >
        <span>{{ info.username }}</span>
        <span>{{ info.phone }}</span>
      </div>
    </router-link>
    <div
      class="share-goods"
      v-for="(item, index) in info.list"
      :key="index"
    >
      <div class="goods-img">
        <img
          :src="imgPrex + item.imageUrl"
          alt
        />
      </div>
      <div class="goods-content">
        <div class="goods-name van-ellipsis">{{ item.name }}</div>
        <div class="goods-money">
          <span class="goods-price"><span>¥</span>{{ item.price }}</span>
          <span
            class="goods-disPrice"
            v-show="item.guidePrice"
          >¥{{ item.guidePrice }}</span>
        </div>
        <div class="goods-num">
          累计获得<span> {{ item.orderNum }} </span>份
        </div>
        <div
          class="goods-buyer"
          @click="callPhone(item.sellerPhone)"
        >
          <img
            src="../../assets/img/goods_send.png"
            alt
          />
          <span>联系商家</span>
        </div>
      </div>
    </div>
    <div
      class="notHave"
      v-show="info.list.length == 0"
    >
      <i class="iconfont icon-personal_image_nosto1"></i>
      <p>当前没有任何记录哦</p>
    </div>
    <van-popup
      v-model="showPhone"
      class="phone-popup"
    >
      <div
        v-for="(item,index) in phoneList"
        :key="index"
        @click="dialPhone(item)"
        class="van-hairline--bottom"
      >{{item}}</div>
    </van-popup>
  </div>
</template>

<script>
import { shareProduct } from "@/api/join";
export default {
  data() {
    return {
      info: {
        list: [],
      },
      phoneList: [],
      showPhone: false
    };
  },
  mounted() {
    shareProduct({}).then((res) => {
      if (res.appStatus.errorCode == 0) {
        this.info = res.content;
      }
    });
  },
  methods: {
    callPhone(phone) {
      let phoneList = phone.split(",");
      if (phoneList.length > 1) {
        this.phoneList = phoneList;
        this.showPhone = true;
      } else {
        this.dialPhone(phone);
      }
    },
    dialPhone(phone) {
      if (this.$store.getters.ambientType != 1) {
        window.location.href = "tel:" + phone;
      } else {
        window.Android.dialPhone(phone);
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.share-tips {
  padding: 5px 15px;
  font-size: 14px;
  background-color: #ffe9d5;
}
.share-address {
  padding: 10px 15px;
  background-color: #ffffff;
  .address,
  .notAddress {
    font-size: 24px;
    font-weight: 800;
    padding-right: 26px;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      display: inline-block;
      top: 50%;
      margin-top: -4px;
      right: 8px;
      width: 8px;
      height: 8px;
      border-top: 1px solid #999999;
      border-left: 1px solid #999999;
      background: 0 0;
      -webkit-transform: rotate(135deg);
      transform: rotate(135deg);
    }
  }
  .notAddress {
    display: inline-block;
    color: #8d8d8d;
  }
  .name {
    margin-top: 6px;
    font-size: 16px;
    span:first-child {
      margin-right: 10px;
    }
  }
}
.share-goods {
  display: flex;
  padding: 10px;
  margin: 10px 10px 0;
  background-color: #ffffff;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.06);
  border-radius: 10px;
  .goods-img {
    width: 110px;
    height: 110px;
    border-radius: 10px;
    overflow: hidden;
    margin-right: 5px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .goods-content {
    flex: 1;
    position: relative;
    overflow: hidden;
    .goods-name {
      font-size: 18px;
      font-weight: 800;
    }
    .goods-money {
      line-height: 15px;
      margin-top: 7px;
    }
    .goods-price {
      font-size: 17px;
      font-weight: 800;
      margin-right: 8px;
      color: #ff1310;
      span {
        font-size: 12px;
      }
    }
    .goods-disPrice {
      font-size: 12px;
      font-weight: 500;
      color: #999999;
      text-decoration: line-through;
    }
    .goods-num {
      font-size: 15px;
      color: #333333;
      position: absolute;
      left: 0;
      bottom: 0;
      span {
        font-weight: 800;
        color: #ff1310;
      }
    }
    .goods-buyer {
      position: absolute;
      right: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #3d7dff;
      img {
        width: 15px;
        height: 15px;
        display: block;
        margin-right: 5px;
      }
    }
  }
}
.notHave {
  margin-top: 178px;
  text-align: center;
  i {
    font-size: 107px;
    color: #d5d5d7;
  }
  p {
    font-size: 15px;
    color: #a3a2a2;
    margin-top: 32px;
  }
}
.phone-popup {
  width: 241px;
  text-align: center;
  border-radius: 5px;
  div {
    font-size: 14px;
    height: 48px;
    line-height: 48px;
  }
}
</style>